import { defineStore } from "pinia";
import { RuleDefinition } from "./CalculationRules/types";
import eventRankingsApi, { GeneratedRankingResponse } from "../Api/eventRankings";
import localStorage from "../Common/store";

const localStorageKey = (eventId: number) => `eventRankingRuleDefinitions_${eventId}`;

export const useEventRankingsStore = defineStore("event-rankings-store", {
    state: () => {
        return {
            eventId: 0,
            definedRules: [] as RuleDefinition[],
            selectedRuleValid: false,
            generatedRanking: { competitors: [] } as GeneratedRankingResponse,
        };
    },
    actions: {
        persistInLocalStorage() {
            localStorage.setObject(localStorageKey(this.eventId), this.definedRules);
        },
        loadFromLocalStorage() {
            const rules = localStorage.getObject<RuleDefinition[]>(localStorageKey(this.eventId));
            if (rules) {
                this.definedRules = rules;
            }
        },
        refreshRanking() {
            return eventRankingsApi.generateRankingForRules(this.eventId, this.definedRules).then(response => {
                this.generatedRanking = response;
            });
        },
    },
});
